import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class UnauthorizedNavigationService {
  private router = inject(Router);

  navigateToUnauthorized(route: ActivatedRouteSnapshot, state?: Record<string, unknown>): void {
    this.navigateTo('/403', route, state);
  }

  navigateToForbidden(route: ActivatedRouteSnapshot, state?: Record<string, unknown>): void {
    this.navigateTo('/forbidden', route, state);
  }

  private navigateTo(target: string, route: ActivatedRouteSnapshot, state?: Record<string, unknown>): void {
    const returnUrl =
      '/' +
      route.pathFromRoot
        .map(r => r.url.map(s => s.path).join('/'))
        .filter(Boolean)
        .join('/');

    void this.router.navigate([target], { state: { returnUrl, ...state } });
  }
}
